<template>
  <a-modal
    title="新建"
    :width="880"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="上级名称">
              <a-tree-select
                style="width: 100%"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                allow-clear
                :tree-data="categoryTreeData"
                v-decorator="[
                  'parent_category_id',
                  {
                    rules: [
                      { required: false, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择品类"
              >
              </a-tree-select>
            </a-form-item>
            <a-form-item label="品类名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:16, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="品类编码">
              <a-input v-decorator="['part_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:3, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="完整编码">
              <a-input v-decorator="['code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:5, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="金蝶物料编码">
              <a-input v-decorator="['jd_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:16, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="提醒">
              <p><strong>"编码"</strong>指的是该品类的编码，例如：原油是101，燃料油是102。</p>
              <p><strong>"完整编码"</strong>指的是该上级分类编码 + 本分类的编码的组合编码，例如：石油编码：11，原油编码是101，原油属于石油，原油的完整编码是11101，燃料油编码是102，也属于石油，完整编码是11102。</p>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { category_list } from '@/api/trade_category'

// 表单字段
const fields = ['id', 'name', 'code']
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this),
      categoryTreeData: [],
      code: ''
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
    this.loadCategory()
  },
  methods: {
    loadCategory () {
      category_list().then((res) => {
        const result = res.data.entries || []
        this.categoryTreeData = this.buildTree(this.transformCategories(result))
      })
    },
    transformCategories (categories) {
      return categories.map(category => ({
        title: category.name,
        value: category.id,
        key: category.id,
        parent_category_id: category.parent_category_id
      }))
    },
    buildTree (categories) {
      const idToNodeMap = {}
      const tree = []
      // 初始化每个节点
      categories.forEach(category => {
        idToNodeMap[category.key] = { ...category, children: [] }
      })
      // 构建树状结构
      categories.forEach(category => {
        const parentId = category.parent_category_id
        if (parentId === -1) {
          tree.push(idToNodeMap[category.key])
        } else {
          idToNodeMap[parentId].children.push(idToNodeMap[category.key])
        }
      })
      return tree
    },
    displayRender ({ labels }) {
      return labels[labels.length - 1]
    }
  }
}
</script>
